import { Box, Card, CircularProgress } from "@mui/material";
import { useEffect, useRef, useState } from "react";


import { useLocation } from "react-router-dom";

import { CategoriesSelection } from "../novos/Services/CategoriesSelection";
import { useServices } from "../../contexts/ServicesContext/projectservices.context";
import { RenderServiceInfo } from "../novos/Services/ActiveService";
import { TabActive } from "../../types/project.type";
import { useProject } from "../../contexts/project.context";

export default function Logistica() {
  const { tabActive } = useProject();
  const { loadingService, createEmptyService, getService, activeService } =
    useServices();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const projectId = searchParams.get("projectId") || "";
  const [collapseSideBar, setCollapseSideBar] = useState(true);
  const [hoveringCollapse, setHoveringCollapse] = useState(false);

  const [pinned, setPinned] = useState(false);

  const leaveTimer = useRef<number | undefined>(undefined);
  const clearLeaveTimer = () => {
    if (leaveTimer.current) window.clearTimeout(leaveTimer.current);
  };
  const suppressHoverRef = useRef(false);




  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<{ pinned: boolean }>;
      const nextPinned = !!ce.detail?.pinned;
      setPinned(nextPinned);

      if (nextPinned) {
        setHoveringCollapse(false);
        suppressHoverRef.current = true;
      } else {
        setCollapseSideBar(true);
        setHoveringCollapse(true); // fica aberto até sair do overlay
        suppressHoverRef.current = false;
      }
    };
    window.addEventListener("rightSidebarPinned", handler as EventListener);
    return () =>
      window.removeEventListener(
        "rightSidebarPinned",
        handler as EventListener
      );
  }, []);



  const isExpanded = pinned || !collapseSideBar || hoveringCollapse;

  const overlayMode = !pinned;


  useEffect(() => {
    async function fetchService() {
      if (tabActive === TabActive.SERVICES && !activeService._id) {
        await getService(projectId);
      }
    }
    fetchService();
  }, [tabActive, projectId]);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      bgcolor={"#F9FCFF"}
      margin={"auto"}
      width={"100%"}
      overflow="hidden"
      borderTop={"1px solid #eee"}
      sx={{ flex: 1, minHeight: 0, height: "100%" }}
    >
      {loadingService ? (
        <Box
          display={"flex"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
          py={10}
          mt={10}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Card
          sx={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            minHeight: 0,
            boxShadow: "0px 4px 18px 0px #4B465C1A",
            position: "relative",
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              overflow: "hidden",
              minHeight: 0,
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CategoriesSelection />
          </Box>

          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              scrollbarWidth: "thin",
              scrollbarColor: "rgba(0, 0, 0, 0.25) transparent",
              "&::-webkit-scrollbar": { width: 6 },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.25)",
                borderRadius: "3px",
              },
            }}
          >
            <Box
              sx={{
                width: overlayMode ? "97%" : isExpanded ? "calc(100% - 60px)" : "96%",
                p: "24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                transition: "width 120ms ease",
              }}
            >
              <RenderServiceInfo />
            </Box>
          </Box>

          {/* <Box
            sx={{
              display: "flex",
              justifyContent: overlayMode
                ? "flex-start"
                : isExpanded
                ? "flex-end"
                : "flex-start",
              ml: 1,
              marginLeft: "auto",
              width: overlayMode ? "20px" : isExpanded ? "400px" : "20px",
              zIndex: 999,
              transition: "width 120ms ease",
              cursor: "default",
              pointerEvents: overlayMode ? "none" : "auto",
            }}
          >
            <Box
              sx={{
                ml: "auto",
                mr: 0,
                py: 1,
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "auto",
                marginTop: 45,
              }}
              onMouseEnter={handleIconEnter}
              onMouseLeave={handleIconLeave}
            >
              {renderCollapseOption(isExpanded)}
            </Box>

            {!overlayMode && (
              <Box
                zIndex={999}
                display={isExpanded ? "block" : "none"}
                bgcolor={"#FFF"}
                sx={{
                  border: "1px solid #ddd",
                  borderTop: "none",
                  p: 1,
                  width: isExpanded ? "calc(100% - 24px)" : 0,
                }}
              >
                <RightSideBar pinned={pinned} />
              </Box>
            )}
          </Box>

          {overlayMode && isExpanded && (
            <Box
              onMouseEnter={handleOverlayEnter}
              onMouseLeave={handleOverlayLeave}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                height: "100%",
                width: 360,
                zIndex: (theme) => theme.zIndex.drawer + 1,
                bgcolor: "white",
                borderLeft: "1px solid #ddd",
                boxShadow: 6,
                display: "block",
              }}
            >
              <Box sx={{ p: 1, height: "100%", overflowY: "auto" }}>
                <RightSideBar pinned={pinned} />
              </Box>
            </Box>
          )} */}
        </Card>
      )}
    </Box>
  );
}
